(function() {
  var Controller, Handler,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  Handler = new (App.loadClass('core::Handler'));

  exports.FinishController = (function(superClass) {
    extend(FinishController, superClass);

    function FinishController(scope, transitions, fields, pgis, zones1, state, timeout, validation) {
      this.scope = scope;
      this.transitions = transitions;
      this.fields = fields;
      this.pgis = pgis;
      this.zones = zones1;
      this.state = state;
      this.timeout = timeout;
      this.validation = validation;
      this.message = bind(this.message, this);
      this.removeBoundaryLayer = bind(this.removeBoundaryLayer, this);
      this.finish = bind(this.finish, this);
      this.validate = bind(this.validate, this);
      this.cleanup = bind(this.cleanup, this);
      this.initializeValidation = bind(this.initializeValidation, this);
      this.initializeVariables = bind(this.initializeVariables, this);
      this.initializeWatchers = bind(this.initializeWatchers, this);
      this.makeBoundaryFeature = bind(this.makeBoundaryFeature, this);
      this.calculateArea = bind(this.calculateArea, this);
      this.getGeometry = bind(this.getGeometry, this);
      this.save = bind(this.save, this);
      this.checkForZonesToSave = bind(this.checkForZonesToSave, this);
      this.formatZoneAreaDataForSave = bind(this.formatZoneAreaDataForSave, this);
      this.formatZoneDataForSave = bind(this.formatZoneDataForSave, this);
      this.saveZone = bind(this.saveZone, this);
      this.saveField = bind(this.saveField, this);
      this.geojsonToWkt = bind(this.geojsonToWkt, this);
      this.initialize = bind(this.initialize, this);
      if (this.validation.canContinue()) {
        this.scope.field_data = this.validation.getFieldData();
        this.validation.setHideNext(true);
        this.validation.setHideBack(true);
        this.initialize();
      }
    }

    FinishController.prototype.initialize = function() {
      this.initializeValidation();
      this.initializeVariables();
      this.initializeWatchers();
      return this.save();
    };

    FinishController.prototype.geojsonToWkt = function(geojson) {
      return this.pgis.geojsonToWkt(geojson).then((function(_this) {
        return function(response) {
          var geometry;
          geometry = response.data.data;
          _this.scope.field_data.geom = geometry;
          return _this.scope.field_data;
        };
      })(this));
    };

    FinishController.prototype.saveField = function(field) {
      var method;
      method = 'saveGeometry';
      return this.fields[method](field, this.validation.api_data_token, this.fields.getYear()).then((function(_this) {
        return function(response) {
          var fields_id;
          if (response.data.status.type === 'success') {
            fields_id = response.data.data.id;
            _this.message('Checking for zones...');
            return fields_id;
          } else {
            return response.data.status.msg;
          }
        };
      })(this));
    };

    FinishController.prototype.saveZone = function(zone, type) {
      return this.scope.save_zones.save(zone).then((function(_this) {
        return function(response) {
          if (response.data.status.type === 'success') {
            return _this.message("Finished saving " + type + " zone");
          } else {
            return _this.message("Failed to save " + type + " zone");
          }
        };
      })(this));
    };

    FinishController.prototype.formatZoneDataForSave = function(fields_id, zone, areas) {
      return {
        id: (zone != null ? zone.id : void 0) != null ? zone.id : false,
        fields_id: fields_id,
        map_data_categories_id: zone.map_data_categories_id,
        zones: areas,
        details: zone.details != null ? zone.details : false,
        extra_info: zone.extra_info,
        year: this.fields.getYear(),
        zone_type: zone.zone_type
      };
    };

    FinishController.prototype.formatZoneAreaDataForSave = function(zones) {
      var i, len, result, zone_area;
      result = [];
      for (i = 0, len = zones.length; i < len; i++) {
        zone_area = zones[i];
        if (zone_area.geojson == null) {
          zone_area.geojson = L.GeoUtil.multiPolygonize(zone_area.visible.toGeoJSON());
        }
        result.push({
          area: turf.area(zone_area.geojson),
          value: zone_area.value,
          geojson: zone_area.geojson
        });
      }
      return result;
    };

    FinishController.prototype.checkForZonesToSave = function(fields_id) {
      var areas, formatted, ref, ref1, results, type, zone;
      ref = this.scope.field_data.zones;
      results = [];
      for (type in ref) {
        zone = ref[type];
        if ((zone != null ? (ref1 = zone.zones) != null ? ref1.length : void 0 : void 0) > 0) {
          this.message("Saving " + type + " zone");
          areas = this.formatZoneAreaDataForSave(zone.zones);
          formatted = this.formatZoneDataForSave(fields_id, zone, areas);
          results.push(this.saveZone(formatted, type).then((function(_this) {
            return function() {
              return _this.scope.count -= 1;
            };
          })(this)));
        } else {
          results.push(this.scope.count -= 1);
        }
      }
      return results;
    };

    FinishController.prototype.save = function() {
      return this.geojsonToWkt(this.scope.geometry).then((function(_this) {
        return function(save_field_object) {
          save_field_object.area = _this.calculateArea(save_field_object.boundary);
          if (save_field_object.geom != null) {
            return _this.saveField(save_field_object).then(function(result) {
              if ($.isNumeric(result)) {
                _this.scope.fields_id = result;
                return _this.checkForZonesToSave(result);
              } else {
                _this.scope.error_message = result;
                return _this.scope.count = -1;
              }
            });
          } else {
            _this.scope.error_message = 'Failed to save field geometry.';
            return _this.scope.count = -1;
          }
        };
      })(this));
    };

    FinishController.prototype.getGeometry = function() {
      var ref, ref1, ref2;
      if (((ref = this.scope) != null ? (ref1 = ref.field_data) != null ? (ref2 = ref1.boundary) != null ? ref2.features : void 0 : void 0 : void 0) != null) {
        return this.scope.field_data.boundary.features[0];
      } else {
        return this.makeBoundaryFeature();
      }
    };

    FinishController.prototype.calculateArea = function(geometry) {
      return (turf.area(geometry) * 0.000247105).toFixed(2);
    };

    FinishController.prototype.makeBoundaryFeature = function() {
      return {
        type: 'Feature',
        properties: {},
        geometry: this.scope.field_data.boundary.geometry
      };
    };

    FinishController.prototype.initializeWatchers = function() {
      return this.scope.$watch('count', (function(_this) {
        return function() {
          if (_this.scope.count === 0) {
            _this.scope.message = 'Finished saving all data!';
            _this.validation.validate();
          }
          if (_this.scope.count === -1) {
            _this.scope.message = _this.scope.error_message;
            return _this.timeout(function() {
              return _this.validation.validate();
            }, 2000);
          }
        };
      })(this));
    };

    FinishController.prototype.initializeVariables = function() {
      this.message('Saving field...');
      this.removeBoundaryLayer();
      this.scope.count = 3;
      this.scope.geometry = this.getGeometry();
      return this.scope.save_zones = this.zones;
    };

    FinishController.prototype.initializeValidation = function() {
      this.scope.validation = this.validation;
      this.scope.validate = this.validate;
      this.scope.validation.setStepScope(this.scope, false);
      this.scope.validation.setText('next', 'Done');
      this.scope.validation.setDisabled('required', true);
      return this.scope.validation.setDisabled('next', true);
    };

    FinishController.prototype.cleanup = function() {
      return delete this.scope.field_data;
    };

    FinishController.prototype.validate = function() {
      var base, i, len, ref, zone_area;
      ref = this.scope.field_data.zones;
      for (i = 0, len = ref.length; i < len; i++) {
        zone_area = ref[i];
        if (typeof (base = zone_area.visible).clearLayers === "function") {
          base.clearLayers();
        }
      }
      return this.finish();
    };

    FinishController.prototype.finish = function() {
      switch (this.scope.field_data.process_mode) {
        case 'irrigation-add':
          this.state.go("grower." + this.scope.validation.settings.redirectState + ".step", {
            id: this.scope.validation.settings.redirectId,
            step: this.scope.validation.settings.step
          });
          break;
        case 'zone-add':
          if (this.scope.validation.settings.from_data) {
            this.state.go('grower.data.view', {
              year: this.fields.getYear(),
              field_id: this.scope.field_data.id
            });
          } else {
            this.state.go("grower." + this.scope.validation.settings.redirectState + ".step", {
              id: this.scope.validation.settings.redirectId,
              step: this.scope.validation.settings.step
            });
          }
          break;
        case 'zone-edit':
        case 'add-crop':
          if (this.scope.validation.settings.from_data) {
            this.state.go('grower.data.view', {
              year: this.fields.getYear(),
              field_id: this.scope.field_data.id
            });
          } else {
            this.state.go("grower." + this.scope.validation.settings.redirectState + ".step", {
              id: this.scope.validation.settings.redirectId,
              step: this.scope.validation.settings.step
            });
          }
          break;
        default:
          this.state.go('grower.fields');
      }
      this.validation.setModeSettings({
        process_mode: 'zone-add'
      });
      return this.validation.clearLayers();
    };

    FinishController.prototype.removeBoundaryLayer = function() {
      var ref;
      if (((ref = this.scope.field_data) != null ? ref.id : void 0) != null) {
        this.pgis.deleteFromLayerStore(this.scope.field_data.id);
        return this.pgis.clearBoundaryLayer();
      }
    };

    FinishController.prototype.message = function(msg) {
      return this.scope.message = msg;
    };

    return FinishController;

  })(Controller);

}).call(this);
